import React from 'react';
import { motion } from 'framer-motion';
import { SectionHeading } from './SectionHeading';
import { trackRecord } from '../data/trackRecord';
export function CareerTrackRecord() {
  return <section id="trackrecord" className="bg-navy py-24 lg:py-32" data-id="element-53" data-mp="299806tmchvjw">
      <div className="max-w-content mx-auto px-6 lg:px-10" data-id="element-54" data-mp="297et5d7tl9bd">
        <SectionHeading eyebrow="07 — Career Track Record" title="Executive Case Studies" description="Five moments of sustained execution across market disruption, expansion, and enterprise-wide delivery." tone="light" data-id="element-55" data-mp="249veic77muiw" />

        <div className="mt-14 grid md:grid-cols-2 gap-6" data-id="element-56" data-mp="1qadmzp2j535u">
          {trackRecord.map((item, index) => <motion.div key={item.number} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.5,
          ease: [0.23, 1, 0.32, 1],
          delay: index % 2 * 0.08
        }} className={`bg-navy-light border border-white/10 p-8 ${index === 4 ? 'md:col-span-2' : ''}`} data-id="element-57" data-mp="1lckhky91wd6m" data-mpi={index}>
              <span className="font-serif text-2xl text-gold" data-id="element-58" data-mp="10sidt9ux69v1">{item.number}</span>
              <h3 className="mt-3 font-serif text-lg sm:text-xl font-semibold text-white" data-id="element-59" data-mp="ms7jtxybcf5n">{item.title}</h3>
              <p className="mt-3 text-sm leading-relaxed text-slate-400 max-w-2xl" data-id="element-60" data-mp="rr212vgmtvnn">{item.summary}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}